import api from './index';
import { AdminMetrics, WindowKey } from './types/adminMetrics';

export async function fetchAdminMetrics(
  window: WindowKey,
  refresh = false
): Promise<AdminMetrics> {
  const response = await api.get<AdminMetrics>('/admin/metrics', {
    params: { window, ...(refresh ? { refresh: 'true' } : {}) }
  });
  return response.data;
}

export interface AdminUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  discordUsername?: string;
}

export async function fetchAdminUsers(): Promise<AdminUser[]> {
  const response = await api.get<{ users: AdminUser[] }>('/admin/users');
  return response.data.users;
}

export async function searchAdminUsers(query: string, limit?: number): Promise<AdminUser[]> {
  const params: { q: string; limit?: number } = { q: query };
  if (limit != null) params.limit = limit;
  const response = await api.get<{ users: AdminUser[] }>('/admin/users/search', {
    params
  });
  return response.data.users;
}

const INITIAL_PREFILL_LIMIT = 20;

export async function fetchInitialAdminUsers(): Promise<AdminUser[]> {
  return searchAdminUsers('', INITIAL_PREFILL_LIMIT);
}

export interface Paged<T> {
  data: T[];
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  hasMore: boolean;
}

export interface SentEmail {
  id: string;
  recipients: string;
  subject: string;
  fromAddress: string;
  template?: string;
  configurationSet?: string;
  messageId?: string;
  status: 'sent' | 'failed';
  error?: string;
  createdAt: string;
}

export async function fetchSentEmails(page = 1, limit = 25): Promise<Paged<SentEmail>> {
  const response = await api.get<Paged<SentEmail>>('/admin/emails', {
    params: { page, limit }
  });
  return response.data;
}
